import { Button } from 'gantri-components';
import { useAtomValue, useSetAtom } from 'jotai';
import { addDesignModalAtoms } from '../../../add-design-modal.atoms';
import { addDesignModalSteps } from '../../../add-design-modal.constants';

export const AddDesignModalSubCategoryStepFooter = () => {
  const setStep = useSetAtom(addDesignModalAtoms.step);
  const subCategory = useAtomValue(addDesignModalAtoms.subCategory);

  const isDisabled = !subCategory;

  return (
    <>
      <Button
        size="large"
        text="Back"
        variant="secondary"
        onClick={() => {
          setStep(addDesignModalSteps.category);
        }}
      />
      <Button
        disabled={isDisabled}
        size="large"
        text="Next"
        onClick={() => {
          setStep(addDesignModalSteps.size);
        }}
      />
    </>
  );
};
